import React from 'react';
import { Checkbox } from 'antd';
import { ContextMenu } from 'Components';
import { TYPE, GRAPH } from 'Types';
import Feather from '@sysunite/react-feather';

const GraphFilterItem = ({
  color,
  enableByDefault,
  enabled,
  value,
  label,
  itemType,
  onChange,
  onClick
}) => {
  const actions = itemType !== GRAPH ? [{
    key: 'toggle-disabled',
    title: `${enableByDefault ? 'Hide' : 'Show'} item by default`,
    onClick: () => onClick(!enableByDefault)
  }] : [];

  return (
    <ContextMenu actions={actions}>
      <div>
        <Checkbox checked={enabled} value={value} onChange={onChange}>
          <span className={!enableByDefault ? 'disabledItem' : ''}>
            {itemType === TYPE && <Feather width="1em" height="1em" type="circle" style={{ fill: color, color }} />}
            {label}
          </span>
        </Checkbox>
      </div>
    </ContextMenu>
  );
};

export default GraphFilterItem;
